module.exports = __webpack_public_path__ + "static/media/expert_male.de8307dd.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/expert_male.svg
// module id = 1399
// module chunks = 0